import { Download, FileCode2, FileText, Printer } from "lucide-react";
import { ExportTheme, PageSize } from "../types";

interface ExportMenuProps {
  pageSize: PageSize;
  margins: number;
  title: string;
  includePageNumbers: boolean;
  exportTheme: ExportTheme;
  onChange: (patch: Partial<{ pageSize: PageSize; margins: number; title: string; includePageNumbers: boolean; exportTheme: ExportTheme }>) => void;
  onPdf: () => void;
  onHtml: () => void;
  onMarkdown: () => void;
}

export const ExportMenu = ({
  pageSize,
  margins,
  title,
  includePageNumbers,
  exportTheme,
  onChange,
  onPdf,
  onHtml,
  onMarkdown,
}: ExportMenuProps) => (
  <aside className="panel export-panel" id="export-menu" aria-label="Export options">
    <div className="panel-title">
      <Download size={18} />
      <span>Export</span>
    </div>
    <label>
      <span>Document title</span>
      <input type="text" value={title} onChange={(event) => onChange({ title: event.target.value })} />
    </label>
    <div className="setting-row">
      <label>
        <span>Page size</span>
        <select value={pageSize} onChange={(event) => onChange({ pageSize: event.target.value as PageSize })}>
          <option value="a4">A4</option>
          <option value="letter">Letter</option>
        </select>
      </label>
      <label>
        <span>Margins (mm)</span>
        <input
          type="number"
          min="8"
          max="40"
          value={margins}
          onChange={(event) => onChange({ margins: Number(event.target.value) })}
        />
      </label>
    </div>
    <label className="check-row">
      <input type="checkbox" checked={includePageNumbers} onChange={(event) => onChange({ includePageNumbers: event.target.checked })} />
      <span>Include page numbers</span>
    </label>
    <label>
      <span>HTML theme</span>
      <select value={exportTheme} onChange={(event) => onChange({ exportTheme: event.target.value as ExportTheme })}>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
    <div className="export-actions">
      <button type="button" onClick={onPdf}>
        <Printer size={16} />
        PDF
      </button>
      <button type="button" onClick={onHtml}>
        <FileCode2 size={16} />
        HTML
      </button>
      <button type="button" onClick={onMarkdown}>
        <FileText size={16} />
        Markdown
      </button>
    </div>
  </aside>
);
